/* Uses the native product form; never adds a variant on the customer's behalf. */
(() => {
  const init = () => {
    const bar = document.querySelector('.f28-mobile-purchase');
    const buy = document.querySelector('.product__info-block--buy_buttons');
    const options = document.querySelector('.product__info-block--variant_picker') || buy;
    if (!bar || !buy || !options || !('IntersectionObserver' in window)) return;
    options.id = 'f28-product-options';
    const mobile = window.matchMedia('(max-width: 749px)');
    const update = () => {
      const box = buy.getBoundingClientRect();
      const overlay = document.querySelector('body.overflow-hidden, body.cart-sidebar-open, cart-drawer.active, .cart-sidebar.active, dialog[open]');
      bar.hidden = !mobile.matches || box.bottom > 0 || !!overlay;
    };
    const observer = new IntersectionObserver(update, {threshold: [0,1]});
    observer.observe(buy);
    window.addEventListener('scroll', update, {passive:true});
    mobile.addEventListener('change', update);
    bar.querySelector('a').addEventListener('click', () => {
      const field = options.querySelector('select,input,button');
      if (field) field.focus({preventScroll:true});
    });
    update();
  };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();
